/* eslint-disable jsx-a11y/anchor-is-valid */

import InView from "react-intersection-observer";

import upImg from "../images/up.svg";
import closeImg from "../images/close-notification.svg";
import { timeSince } from "../utils/utils";
import FormatUtils from "../utils/formatUtils";
import history from "../utils/history";

const NotificationItem = (props) => {
  let clientNotifications = props.clientNotifications;
  let notifications = clientNotifications.Notifications;
  let clientId = clientNotifications.ClientId;
  let notReadEventsCount = clientNotifications.AllNotificationsLoaded
    ? notifications.filter((n) => !n.Read).length
    : clientNotifications.UnreadEventsCount;
  let visibleNotifications = notifications.filter((n) => !n.Hidden);
  let anyVisibleNotifications = visibleNotifications.length > 0;

  if (!anyVisibleNotifications && notReadEventsCount === 0) {
    return null;
  }

  let goToClient = (e) => {
    e.stopPropagation();
    props.closeActiveHub();
    history.push(`/client/${clientId}`);
  };

  let goToQuote = (e, quoteIdToOpen) => {
    props.closeActiveHub();
    history.push(`/client/${clientId}/${quoteIdToOpen}`);
  };

  return (
    <div className="notification-item" data-testid="rolldown-item">
      <div
        className="collapsible"
        onClick={() => {
          if (anyVisibleNotifications) {
            props.toggle();
          }
        }}
      >
        <div className="new-notification">
          {notReadEventsCount > 0 ? (
            <div className="new-notification-icon">{notReadEventsCount}</div>
          ) : null}
        </div>
        <div className="notificaion-info">
          <p
            className="client-name"
            onClick={goToClient}
            data-testid="client-name"
          >
            {clientNotifications.BusinessName}
          </p>
          <p
            className="client-code"
            onClick={goToClient}
            data-testid="client-id"
          >
            {clientNotifications.ClientNumber}
          </p>
        </div>
        <div className="notification-age">
          <span data-testid="notification-date">
            {timeSince(
              new Date(clientNotifications.MostRecentNotificationDate)
            )}
            &nbsp;ago
          </span>
        </div>
        {anyVisibleNotifications && (
          <a
            className={
              props.isClientExpanded ? "item-arrow" : " item-arrow-collapsed"
            }
            onClick={() => props.toggle()}
            data-testid="client-expand"
          >
            <img alt="" src={upImg} width="14px" height="8px" />
          </a>
        )}
      </div>
      {props.isClientExpanded && anyVisibleNotifications && (
        <div className="notification-content">
          <div className="notification-options">
            <a
              className="option"
              onClick={() =>
                props.readClientAction(clientId, notReadEventsCount === 0)
              }
            >
              {notReadEventsCount > 0
                ? "Mark ALL as read"
                : "Mark ALL as unread"}
            </a>
            <a
              className="option clear"
              onClick={() => props.clearClientAction(clientId)}
            >
              Clear ALL
            </a>
          </div>
          {visibleNotifications.map((notification, index) => {
            let { statusBg, fontColor } = FormatUtils.getStatusStyle(
              notification.EventType
            );
            let hasQuoteNumber = notification.QuoteNumber > 0;
            let cursor = hasQuoteNumber ? "pointer" : "inherit";

            return (
              <div
                key={index}
                className="event-item"
                onClick={() =>
                  props.readNotification(notification.Key, !notification.Read)
                }
              >
                <div className="new-event">
                  {
                    <div
                      className={
                        !notification.Read
                          ? "new-event-icon"
                          : "read-event-icon"
                      }
                      title={
                        notification.Read ? "Mark as unread" : "Mark as read"
                      }
                    ></div>
                  }
                </div>
                <div
                  style={{ cursor: cursor }}
                  onClick={(e) => {
                    if (hasQuoteNumber) {
                      e.stopPropagation();
                      goToQuote(e, notification.QuoteId);
                    }
                  }}
                >
                  <span
                    className={"event-type"}
                    style={{ backgroundColor: statusBg, color: fontColor }}
                    data-testid="event-type"
                  >
                    {notification.DisplayName}
                  </span>
                  <span className="event-id" data-testid="quote-id">
                    {hasQuoteNumber ? notification.QuoteNumber : ""}
                  </span>{" "}
                  <br />
                  <span>
                    <div className="event-title" data-testid="carrier-name">
                      {notification.BillingCarrierName}
                    </div>
                    <span
                      className="event-buisnessType"
                      data-testid="lob-description"
                    >
                      {notification.LOBDescription}
                    </span>
                  </span>
                </div>
                <div style={{ marginLeft: "auto" }}>
                  {
                    <span className="event-time">
                      {timeSince(notification.EventDate)}&nbsp;ago
                    </span>
                  }
                  <a
                    title="Clear notification"
                    className="event-close"
                    data-testid="clear-notification"
                    onClick={(e) => {
                      e.stopPropagation();
                      props.clearNotification(notification.Key);
                    }}
                  >
                    <img src={closeImg} alt="" />
                  </a>
                </div>
              </div>
            );
          })}
          {!clientNotifications.AllNotificationsLoaded && (
            <InView
              onChange={(inView) => {
                if (inView) {
                  props.loadAgencyClientNotifications(clientId);
                }
              }}
            >
              <div className="loading-notifications">...Loading</div>
            </InView>
          )}
        </div>
      )}
    </div>
  );
};

export default NotificationItem;
